import {
    Card,
    Center,
    Container,
    Grid,
    Group,
    Stack,
    Text,
    Title
} from "@mantine/core";
import {AiOutlineArrowRight} from "react-icons/ai";
import {NavLink} from "react-router-dom";

import {sections} from "../sections";

export const IndexPage = () => {

    const visibleSections = sections.filter((section) => section.visible);

    return (
        <Container>
            <Center p={'xl'}>
                <Title>Getting Started</Title>
            </Center>

            {visibleSections.map((section, index) =>
                                     <Card p={'xl'} m={'xl'} shadow={'sm'} key={index}>
                                         <Grid>
                                             <Grid.Col span={2}>
                                                 {section.icon}
                                             </Grid.Col>

                                             <Grid.Col span={7}>
                                                 <Stack>
                                                     <Group>
                                                         <Title order={2}>{section.title}</Title>
                                                     </Group>
                                                     <Text
                                                         style={{color: 'var(--mantine-color-gray-6)'}}>{section.text}</Text>
                                                 </Stack>
                                             </Grid.Col>

                                             <Grid.Col span={3}>
                                                 <Group justify={'flex-end'}>
                                                     <NavLink to={section.link.path}>
                                                         <Group>
                                                             <Text> {section.link.title}</Text>
                                                             <AiOutlineArrowRight/>
                                                         </Group>
                                                     </NavLink>
                                                 </Group>
                                             </Grid.Col>
                                         </Grid>
                                     </Card>
            )}
        </Container>
    )

};
